import { Incident } from '@/types/community/incident';

export const incidents: Incident[] = [
  {
    id: 'incident-1',
    title: 'Vazamento de Água',
    description: 'Vazamento de água no corredor do 2º andar',
    type: 'safety',
    priority: 'high',
    status: 'reported',
    block: {
      id: 'block-1',
      name: 'Bloco A'
    },
    apartmentUnit: {
      id: 'unit-201',
      name: 'Unidade 201'
    },
    reportedBy: {
      id: 'resident-1',
      name: 'Maria Santos',
      type: 'resident'
    },
    reportedAt: new Date('2024-01-15T10:30:00'),
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'incident-2',
    title: 'Barulho Excessivo',
    description: 'Barulho excessivo vindo do apartamento 305',
    type: 'noise',
    priority: 'medium',
    status: 'investigating',
    block: {
      id: 'block-2',
      name: 'Bloco B'
    },
    apartmentUnit: {
      id: 'unit-305',
      name: 'Unidade 305'
    },
    reportedBy: {
      id: 'resident-2',
      name: 'Carlos Oliveira',
      type: 'resident'
    },
    reportedAt: new Date('2024-01-16T22:15:00'),
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'incident-3',
    title: 'Problema de Segurança',
    description: 'Porta da entrada principal não está fechando corretamente',
    type: 'security',
    priority: 'high',
    status: 'investigating',
    block: {
      id: 'block-1',
      name: 'Bloco A'
    },
    reportedBy: {
      id: 'employee-1',
      name: 'João Silva',
      type: 'employee'
    },
    reportedAt: new Date('2024-01-17T08:45:00'),
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'incident-4',
    title: 'Área Desorganizada',
    description: 'Área de lazer está desorganizada e suja',
    type: 'untidy',
    priority: 'low',
    status: 'resolved',
    block: {
      id: 'block-2',
      name: 'Bloco B'
    },
    reportedBy: {
      id: 'resident-3',
      name: 'Ana Costa',
      type: 'resident'
    },
    reportedAt: new Date('2024-01-18T14:20:00'),
    resolvedAt: new Date('2024-01-19T10:00:00'),
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'incident-5',
    title: 'Problema Elétrico',
    description: 'Luzes do estacionamento não estão funcionando',
    type: 'safety',
    priority: 'medium',
    status: 'reported',
    block: {
      id: 'block-1',
      name: 'Bloco A'
    },
    reportedBy: {
      id: 'employee-2',
      name: 'Maria Santos',
      type: 'employee'
    },
    reportedAt: new Date('2024-01-20T16:30:00'),
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  }
]; 